import React from "react"
import TitleStyled from "./styles/titleStyles"
import QuotationStyled from "./styles/QuotationStyles"
import uuid from "react-uuid"
import myInitObject from "../ultis/variable"
import Slider from "react-slick"

const Quotation = ({ heading, quoteSign, quotation }) => {
  const currentWidth = typeof window !== `undefined` ? window.innerWidth : 0
  const settings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    autoplay: true,
    speed: 1000,
    autoplaySpeed: 4000,
    // cssEase: "linear",
  }
  return (
    <QuotationStyled quoteSign={myInitObject.cockpitUrl + quoteSign}>
      <div className="container">
        <TitleStyled textAlign="center" linePosition="center" color="#000">
          <h2 dangerouslySetInnerHTML={{ __html: heading }}></h2>
        </TitleStyled>
        <div className="quotation__wrapper">
          {currentWidth > 880 ? (
            <>
              {quotation.map(item => (
                <div key={uuid()} className="quotation__item">
                  <div className="quotation__text">
                    <p
                      className="quotation__text__para"
                      dangerouslySetInnerHTML={{ __html: item.value.text }}
                    ></p>
                    <p
                      className="quotation__text__author"
                      dangerouslySetInnerHTML={{ __html: item.value.author }}
                    ></p>
                  </div>
                  <div className="quotation__img">
                    {item.value.img ? (
                      <img
                        src={myInitObject.cockpitUrl + item.value.img.path}
                        alt=""
                      />
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div className="rotator__wrapper">
              <Slider {...settings}>
                {quotation.map(item => (
                  <div key={uuid()} className="rotator__item quotation__item">
                    <div className="quotation__text">
                      <p
                        className="quotation__text__para"
                        dangerouslySetInnerHTML={{ __html: item.value.text }}
                      ></p>
                      <p
                        className="quotation__text__author"
                        dangerouslySetInnerHTML={{
                          __html: item.value.author,
                        }}
                      ></p>
                    </div>
                    <div className="quotation__img">
                      {item.value.img ? (
                        <img
                          src={myInitObject.cockpitUrl + item.value.img.path}
                          alt=""
                        />
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                ))}
              </Slider>
            </div>
          )}
        </div>
      </div>
    </QuotationStyled>
  )
}

export default Quotation
